module.exports = __webpack_public_path__ + "img/icon-shop.12085c74.svg";